import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

const MAX_QUANTITY = 1_000_000;

const AdjustInventoryLevelInput_ = z
  .object({
    storageLocationId: storageLocationIdFormat.schema,
    /**
     * The inventory_level row is identified by its natural key — the bin plus
     * the product and/or inventory item. At least one of the two is required.
     */
    productId: productIdFormat.schema.nullish(),
    inventoryItemId: inventoryItemIdFormat.schema.nullish(),
    /** "set" treats amount as the new absolute quantity; "adjust" as a signed delta. */
    mode: z.enum(["set", "adjust"]),
    amount: z.number().int().min(-MAX_QUANTITY).max(MAX_QUANTITY),
    note: z.string().max(1000).nullish(),
  })
  .superRefine((input, ctx) => {
    if (!input.productId && !input.inventoryItemId) {
      ctx.addIssue({
        code: "custom",
        path: ["productId"],
        message: "A productId or inventoryItemId is required",
      });
    }
    if (input.mode === "set" && input.amount < 0) {
      ctx.addIssue({
        code: "custom",
        path: ["amount"],
        message: "An absolute quantity cannot be negative",
      });
    }
  });

export const adjustInventoryLevel = {
  name: "adjustInventoryLevel" as const,
  input: AdjustInventoryLevelInput_,
  output: z.object({
    previousQuantity: z.number().int(),
    newQuantity: z.number().int(),
  }),
};
